import { createApiClient, type ApiClient } from '@bitwize/api-client';

/**
 * The API client a browser-side public component uses — the contact form,
 * so far the only place on the public site that issues a request from the
 * client rather than through a `+data.ts` on the server.
 *
 * Unauthenticated by construction: there is no `getAccessToken`, because a
 * visitor filling in the contact form never has a session. Distinct from
 * both `serverApiClient` (server-only, `API_INTERNAL_URL`) and the admin's
 * client in `shared/auth/api.ts` (carries a bearer token) even though this
 * one and the admin's read the same `PUBLIC_ENV__API_URL`.
 */
export function publicApiClient(locale?: string): ApiClient {
  const baseUrl = import.meta.env.PUBLIC_ENV__API_URL;
  if (!baseUrl) {
    throw new Error('PUBLIC_ENV__API_URL is not configured');
  }
  return createApiClient({ baseUrl, ...(locale ? { locale } : {}) });
}
